export default __webpack_public_path__ + "static/bannerInStorePaymentsBg-235f908a59018f33dcb1c7ab2a20d70f.png";